import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
import Genres from '../genres/genres';
import moment from 'moment';
import ScheduleAdd from '../schedule/add';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

import './donation.css';

export default class Donation extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			show: false,
			DonationListener: null,
			donations: [],
		};
		this.close = this.close.bind(this);
  };

  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		const DonationListener = EventEmitter.addListener('/donation/donate',async (data) => {
			let params = new URLSearchParams();
			params.append('uid', data.uid);
			const x = await postApi('/api/v2/donation', params);
			if( x.status === 200 ) {
				if( x.data.length === 1 && x.data[0].length === 1 ) {
					//console.log(x.data[0][0].option1);
					window.open(x.data[0][0].option1, "_blank", "noreferrer");
				} else {
					this.setState({show: true, donations: x.data});
				}
			}

		}); this.setState({DonationListener});
	}

	componentWillUnmount() {
		if( this.state.DonationListener ) this.state.DonationListener.remove();
	}

	close() {
		this.setState({ show: false });
	}

	render() {
		//const user = this.context;
		const donations = 
			this.state.donations.map((e,i) => {
				return (
					<React.Fragment key={i}>
						<Col xs={12}>
							<h4 className="donation-header">Donate to {this.state.donations[i][0].title?this.state.donations[i][0].title:this.state.donations[i][0].username}</h4>
							{this.state.donations[i][0].donation}
						</Col>
						{this.state.donations[i].map((f,j) => {
							return (
								<Col md={6} className="text-center mb-3" key={j}>
									<a href={this.state.donations[i][j].option1} target="_blank" rel="noreferrer">
										{this.state.donations[i][j].type === 1 &&
											<img src="/images/paypal.png" alt="Donate via Paypal" width="30%" />
										}
										{this.state.donations[i][j].type === 2 &&
											<img src="/images/ko-fi.png" alt="Donate via Ko-fi" width="30%" />
										}<br />
										<Button size="sm mt-3">Donate</Button>
									</a><br />
								</Col>
							)
						})}
					</React.Fragment>
				)});
		return (
			<>
				{this.state.show &&
					<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
						<Modal.Header closeButton className="bg-dark">
							<Modal.Title>Donation</Modal.Title>
						</Modal.Header>
						<Modal.Body className="bg-dark">
							<Row className="gx-0">
								{donations}
							</Row>
						</Modal.Body>
						<Modal.Footer className="bg-dark">
							{/*
							<Button variant="secondary" onClick={this.close}>
								Close
							</Button>
							*/}
							<Button variant="primary" onClick={this.close}>OK</Button>
						</Modal.Footer>
					</Modal>
				}
			</>
		);
	}
}

